import { Injectable } from '@angular/core';

import { NgRedux } from '@angular-redux/store';

import { Observable } from 'rxjs';

import * as AuthParametersSelectors from './auth-parameters.selectors';
import { AuthParametersActions } from './auth-parameters.actions';

@Injectable()
export class AuthParametersFacade {
    callback$: Observable<string> = this.store.select(AuthParametersSelectors.getCallback);

    constructor(
        private store: NgRedux<any>,
        private action: AuthParametersActions,
    ) {}

    setCallback(callback: string) {
        this.store.dispatch(this.action.setCallback(callback));
    }

    reset() {
        this.store.dispatch(this.action.reset());
    }
}
